import * as React from 'react';
import type {
  CreateInvoiceJustificationPayload as Payload,
} from 'contracts/tracking-v2/invoice-justifications';
import { api, handleApiError } from 'services/api';

export const useCreateInvoiceJustification = () => {
  const createInvoiceJustification = React.useCallback(async (payload: Payload) => {
    try {
      await api.post('/invoice/justifications', payload);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    createInvoiceJustification,
  };
};